'use strict';

/**
 * Get first address component by type
 *
 * @param   {Object} address_components[] - Set of addresses
 * @param   {String} component_type       - Type to retrieve
 * @returns {Object|undefined}            - First address result matching type
 */
var getAddressComponentType, getAlternateAddressFormat;

getAddressComponentType = function(arg, component_type) {
  var address_components;
  address_components = arg.address_components;
  return _.find(address_components, function(arg1) {
    var types;
    types = arg1.types;
    return _.some(types, function(type) {
      return type === component_type;
    });
  });
};


/**
 * Get address name
 *
 * @param   {Object} result                      - Google maps result object
 * @param   {Array}  result.address_components[] - Array with address_components describing result
 * @param   {String} result.formatted_address    - Localized nice name for result
 * @returns {String}
 */

getAlternateAddressFormat = function(result) {
  var address;
  if ((address = getAddressComponentType(result, 'sublocality_level_1')) != null) {
    return address.short_name;
  } else if ((address = getAddressComponentType(result, 'locality')) != null) {
    return address.long_name;
  } else if ((address = getAddressComponentType(result, 'administrative_area_level_1')) != null) {
    return address.short_name;
  } else {
    return result.formatted_address;
  }
};

module.exports = {
  getAddressComponentType: getAddressComponentType,
  getAlternateAddressFormat: getAlternateAddressFormat
};

